module.exports = __webpack_public_path__ + "static/Farfetch-unselect-51f27f570cf7ef9cf5da330c36e64aaf.png";